import { __assign } from "tslib";
import { Kind, TypeInfo, visit, visitWithTypeInfo, } from 'graphql';
import { collectFields } from '@graphql-tools/utils';
var VisitSelectionSets = /** @class */ (function () {
    function VisitSelectionSets(visitor) {
        this.visitor = visitor;
    }
    VisitSelectionSets.prototype.transformRequest = function (originalRequest, delegationContext, _transformationContext) {
        var document = visitSelectionSets(originalRequest, delegationContext.info.schema, delegationContext.returnType, this.visitor);
        return __assign(__assign({}, originalRequest), { document: document });
    };
    return VisitSelectionSets;
}());
export default VisitSelectionSets;
function visitSelectionSets(request, schema, initialType, visitor) {
    var document = request.document, variables = request.variables;
    var operations = [];
    var fragments = Object.create(null);
    document.definitions.forEach(function (def) {
        if (def.kind === Kind.OPERATION_DEFINITION) {
            operations.push(def);
        }
        else if (def.kind === Kind.FRAGMENT_DEFINITION) {
            fragments[def.name.value] = def;
        }
    });
    var partialExecutionContext = {
        schema: schema,
        variableValues: variables,
        fragments: fragments,
    };
    var typeInfo = new TypeInfo(schema, undefined, initialType);
    var newDefinitions = operations.map(function (operation) {
        var type = operation.operation === 'query'
            ? schema.getQueryType()
            : operation.operation === 'mutation'
                ? schema.getMutationType()
                : schema.getSubscriptionType();
        var fields = collectFields(partialExecutionContext, type, operation.selectionSet, Object.create(null), Object.create(null));
        var newSelections = [];
        Object.keys(fields).forEach(function (responseKey) {
            var fieldNodes = fields[responseKey];
            fieldNodes.forEach(function (fieldNode) {
                var _a;
                var selectionSet = fieldNode.selectionSet;
                if (selectionSet == null) {
                    newSelections.push(fieldNode);
                    return;
                }
                var newSelectionSet = visit(selectionSet, visitWithTypeInfo(typeInfo, (_a = {},
                    _a[Kind.SELECTION_SET] = function (node) { return visitor(node, typeInfo); },
                    _a)));
                if (newSelectionSet === selectionSet) {
                    newSelections.push(fieldNode);
                    return;
                }
                newSelections.push(__assign(__assign({}, fieldNode), { selectionSet: newSelectionSet }));
            });
        });
        return __assign(__assign({}, operation), { selectionSet: {
                kind: Kind.SELECTION_SET,
                selections: newSelections,
            } });
    });
    Object.values(fragments).forEach(function (fragment) {
        var _a;
        newDefinitions.push(visit(fragment, visitWithTypeInfo(typeInfo, (_a = {},
            _a[Kind.SELECTION_SET] = function (node) { return visitor(node, typeInfo); },
            _a))));
    });
    return __assign(__assign({}, document), { definitions: newDefinitions });
}
//# sourceMappingURL=VisitSelectionSets.js.map